const railwaysInfo = [
  {
    cities: ['Edinburgh', 'London'],
    color: 'black',
    id: 'path-0',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Bruxelles', 'Amsterdam'],
    color: 'black',
    id: 'path-1',
    points: 1,
    trainsAmount: 1,
  },
  {
    cities: ['Brest', 'Paris'],
    color: 'black',
    id: 'path-2',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Frankfurt', 'Berlin'],
    color: 'black',
    id: 'path-3',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Venezia', 'Roma'],
    color: 'black',
    id: 'path-4',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Riga', 'Danzig'],
    color: 'black',
    id: 'path-5',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Erzurum', 'Angora'],
    color: 'black',
    id: 'path-6',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Bruxelles', 'Frankfurt'],
    color: 'blue',
    id: 'path-7',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Essen', 'Berlin'],
    color: 'blue',
    id: 'path-8',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Paris', 'Pamplona'],
    color: 'blue',
    id: 'path-9',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Wien', 'Warszawa'],
    color: 'blue',
    id: 'path-10',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Venezia', 'Munchen'],
    color: 'blue',
    id: 'path-11',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Wilno', 'Petrograd'],
    color: 'blue',
    id: 'path-12',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Constantinople', 'Sofia'],
    color: 'blue',
    id: 'path-13',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Lisboa', 'Cadiz'],
    color: 'blue',
    id: 'path-14',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Dieppe', 'Bruxelles'],
    color: 'green',
    id: 'path-15',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Essen', 'Frankfurt'],
    color: 'green',
    id: 'path-16',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Paris', 'Pamplona'],
    color: 'green',
    id: 'path-17',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Zurich', 'Venezia'],
    color: 'green',
    id: 'path-18',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Berlin', 'Wien'],
    color: 'green',
    id: 'path-19',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Riga', 'Wilno'],
    color: 'green',
    id: 'path-20',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Rostov', 'Kharkov'],
    color: 'green',
    id: 'path-21',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Athina', 'Sarajevo'],
    color: 'green',
    id: 'path-22',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Edinburgh', 'London'],
    color: 'orange',
    id: 'path-23',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Dieppe', 'Brest'],
    color: 'orange',
    id: 'path-24',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Paris', 'Frankfurt'],
    color: 'orange',
    id: 'path-25',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Wien', 'Munchen'],
    color: 'orange',
    id: 'path-26',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Budapest', 'Zagrab'],
    color: 'orange',
    id: 'path-27',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Moskva', 'Smolensk'],
    color: 'orange',
    id: 'path-28',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Smyrna', 'Angora'],
    color: 'orange',
    id: 'path-29',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Madrid', 'Cadiz'],
    color: 'orange',
    id: 'path-30',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Bruxelles', 'Paris'],
    color: 'red',
    id: 'path-31',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Pamplona', 'Marseille'],
    color: 'red',
    id: 'path-32',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Frankfurt', 'Berlin'],
    color: 'red',
    id: 'path-33',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Wien', 'Budapest'],
    color: 'red',
    id: 'path-34',
    points: 1,
    trainsAmount: 1,
  },
  {
    cities: ['Kyiv', 'Smolensk'],
    color: 'red',
    id: 'path-35',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Wilno', 'Warszawa'],
    color: 'red',
    id: 'path-36',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Erzurum', 'Sochi'],
    color: 'red',
    id: 'path-37',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Sarajevo', 'Zagrab'],
    color: 'red',
    id: 'path-38',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Brest', 'Pamplona'],
    color: 'purple',
    id: 'path-39',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Zurich', 'Marseille'],
    color: 'purple',
    id: 'path-40',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Frankfurt', 'Munchen'],
    color: 'purple',
    id: 'path-41',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Berlin', 'Warszawa'],
    color: 'purple',
    id: 'path-42',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Budapest', 'Sarajevo'],
    color: 'purple',
    id: 'path-43',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Athina', 'Sofia'],
    color: 'purple',
    id: 'path-44',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Madrid', 'Lisboa'],
    color: 'purple',
    id: 'path-45',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Amsterdam', 'Frankfurt'],
    color: 'white',
    id: 'path-46',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Kobenhavn', 'Stockholm'],
    color: 'white',
    id: 'path-47',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Paris', 'Frankfurt'],
    color: 'white',
    id: 'path-48',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Wien', 'Budapest'],
    color: 'white',
    id: 'path-49',
    points: 1,
    trainsAmount: 1,
  },
  {
    cities: ['Petrograd', 'Moskva'],
    color: 'white',
    id: 'path-50',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Sevastopol', 'Bucuresti'],
    color: 'white',
    id: 'path-51',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Roma', 'Brindisi'],
    color: 'white',
    id: 'path-52',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Madrid', 'Pamplona'],
    color: 'white',
    id: 'path-53',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Amsterdam', 'Essen'],
    color: 'yellow',
    id: 'path-54',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Bruxelles', 'Paris'],
    color: 'yellow',
    id: 'path-55',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Kobenhavn', 'Stockholm'],
    color: 'yellow',
    id: 'path-56',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Zurich', 'Munchen'],
    color: 'yellow',
    id: 'path-57',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Berlin', 'Warszawa'],
    color: 'yellow',
    id: 'path-58',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Wilno', 'Smolensk'],
    color: 'yellow',
    id: 'path-59',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Constantinople', 'Bucuresti'],
    color: 'yellow',
    id: 'path-60',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Barcelona', 'Madrid'],
    color: 'yellow',
    id: 'path-61',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['London', 'Dieppe'],
    color: 'multi',
    id: 'path-62',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['London', 'Dieppe'],
    color: 'multi',
    id: 'path-63',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['London', 'Amsterdam'],
    color: 'multi',
    id: 'path-64',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Essen', 'Kobenhavn'],
    color: 'multi',
    id: 'path-65',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Essen', 'Kobenhavn'],
    color: 'multi',
    id: 'path-66',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Paris', 'Zurich'],
    color: 'multi',
    id: 'path-67',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Paris', 'Marseille'],
    color: 'multi',
    id: 'path-68',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Berlin', 'Danzig'],
    color: 'multi',
    id: 'path-69',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Wien', 'Zagrab'],
    color: 'multi',
    id: 'path-70',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Venezia', 'Zagrab'],
    color: 'multi',
    id: 'path-71',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Budapest', 'Kyiv'],
    color: 'multi',
    id: 'path-72',
    points: 15,
    trainsAmount: 6,
  },
  {
    cities: ['Budapest', 'Bucuresti'],
    color: 'multi',
    id: 'path-73',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Stockholm', 'Petrograd'],
    color: 'multi',
    id: 'path-74',
    points: 21,
    trainsAmount: 8,
  },
  {
    cities: ['Moskva', 'Kharkov'],
    color: 'multi',
    id: 'path-75',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Kyiv', 'Warszawa'],
    color: 'multi',
    id: 'path-76',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Kyiv', 'Wilno'],
    color: 'multi',
    id: 'path-77',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Kyiv', 'Kharkov'],
    color: 'multi',
    id: 'path-78',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Kyiv', 'Bucuresti'],
    color: 'multi',
    id: 'path-79',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Riga', 'Petrograd'],
    color: 'multi',
    id: 'path-80',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Rostov', 'Sevastopol'],
    color: 'multi',
    id: 'path-81',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Rostov', 'Sochi'],
    color: 'multi',
    id: 'path-82',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Erzurum', 'Sevastopol'],
    color: 'multi',
    id: 'path-83',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Sevastopol', 'Sochi'],
    color: 'multi',
    id: 'path-84',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Sevastopol', 'Constantinople'],
    color: 'multi',
    id: 'path-85',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Constantinople', 'Smyrna'],
    color: 'multi',
    id: 'path-86',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Constantinople', 'Angora'],
    color: 'multi',
    id: 'path-87',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Smyrna', 'Palermo'],
    color: 'multi',
    id: 'path-88',
    points: 15,
    trainsAmount: 6,
  },
  {
    cities: ['Smyrna', 'Athina'],
    color: 'multi',
    id: 'path-89',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Athina', 'Brindisi'],
    color: 'multi',
    id: 'path-90',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Roma', 'Marseille'],
    color: 'multi',
    id: 'path-91',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Roma', 'Palermo'],
    color: 'multi',
    id: 'path-92',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Brindisi', 'Palermo'],
    color: 'multi',
    id: 'path-93',
    points: 4,
    trainsAmount: 3,
  },
  {
    cities: ['Sofia', 'Sarajevo'],
    color: 'multi',
    id: 'path-94',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Sofia', 'Bucuresti'],
    color: 'multi',
    id: 'path-95',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Warszawa', 'Danzig'],
    color: 'multi',
    id: 'path-96',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Barcelona', 'Pamplona'],
    color: 'multi',
    id: 'path-97',
    points: 2,
    trainsAmount: 2,
  },
  {
    cities: ['Barcelona', 'Marseille'],
    color: 'multi',
    id: 'path-98',
    points: 7,
    trainsAmount: 4,
  },
  {
    cities: ['Madrid', 'Pamplona'],
    color: 'multi',
    id: 'path-99',
    points: 4,
    trainsAmount: 3,
  },
];

export default railwaysInfo;
